import React from 'react';
import { Check } from 'lucide-react';

const STEPS = [
  { number: 1, title: 'Project Setup', description: 'Configure framework and categories' },
  { number: 2, title: 'Connect Integrations', description: 'Link your cloud services' },
  { number: 3, title: 'Scan & Analysis', description: 'Run initial gap assessment' },
  { number: 4, title: 'Risk Assessment', description: 'Review your AI-generated risks' },
];

const WizardProgress = ({ currentStep, steps = STEPS }) => {
  return (
    <div className="w-full py-6">
      <div className="flex items-center justify-between gap-1 sm:gap-0">
        {steps.map((step, index) => {
          const isCompleted = currentStep > step.number;
          const isCurrent = currentStep === step.number;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.number}>
              {/* Step Circle and Label */}
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
                    transition-all duration-200
                    ${isCompleted
                      ? 'bg-teal-600 text-white'
                      : isCurrent
                        ? 'bg-teal-600 text-white ring-4 ring-teal-100'
                        : 'bg-gray-200 text-gray-500'
                    }
                  `}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    step.number
                  )}
                </div>
                <div className="mt-3 text-center">
                  <p
                    className={`
                      text-xs sm:text-sm font-medium
                      ${isCurrent || isCompleted ? 'text-gray-900' : 'text-gray-500'}
                    `}
                  >
                    {step.title}
                  </p>
                  <p className="text-xs text-gray-500 mt-1 hidden sm:block">
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Connector Line */}
              {!isLast && (
                <div className="flex-1 mx-1 sm:mx-4 mb-12 sm:mb-8">
                  <div
                    className={`
                      h-1 rounded-full transition-all duration-200
                      ${isCompleted ? 'bg-teal-600' : 'bg-gray-200'}
                    `}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default WizardProgress;
